import Vue from 'vue'
import App from './app/App.vue'
import { router, i18n } from './_helpers'
import vuetify from './_vuetify'
import 'vuetify/dist/vuetify.min.css'
import HighchartsVue from 'highcharts-vue'
import Highcharts from 'highcharts'
import highchartsMore from 'highcharts/highcharts-more'
import { extend } from 'vee-validate'
import { required, min } from 'vee-validate/dist/rules'

extend('required', { ...required })
extend('min', { ...min })
export const dashboardMixIn = {
  methods: {
    $translatedErrorMessages: function (errors, name) {
      if (errors && Object.keys(errors).length > 0) {
        for (let [key] of Object.entries(errors)) {
          return this.$t(`msg.${name}_error_${key}`.toString().toLowerCase())
        }
      }
    }
  }
}
Vue.mixin(dashboardMixIn)
Vue.config.productionTip = false
export const EventBus = new Vue()
Vue.use({ Highcharts })
highchartsMore(Highcharts)
Vue.use(HighchartsVue)

new Vue({
  router,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
